import { RPCDocs } from "../../../../../services/rpc.js";
import { FormikNumber } from "../../../../../components/FormikFields/FormikNumber.js";
import { FormikSelect } from "../../../../../components/FormikFields/FormikSelect.js";
import { FormikSelectRecordTag } from "../../FormikSelectRecordTag.js";
import { useRecordsFieldOptionsConfig } from "../../../../RecordsFieldOptionsConfig/context.js";
import { toOptions } from "../../../../RecordsFieldOptionsConfig/utils.js";
import { TbArrowBigRightFilled } from "react-icons/tb";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
//#region src/modules/Records/shared/RecordSearchFilters/components/PersonFields.tsx
function PersonFields() {
	const { values } = useFormikContext();
	const config = useRecordsFieldOptionsConfig();
	return /* @__PURE__ */ jsx("div", {
		className: "flex w-full flex-col",
		children: values.config.showAdvancedFilters && /* @__PURE__ */ jsxs("div", {
			className: "gap-xxs grid grid-cols-2 md:grid-cols-4",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsxs("div", {
						className: "gap-xxs bg-input-background flex items-center justify-center",
						children: [
							/* @__PURE__ */ jsx(FormikNumber, {
								name: "person.ageFrom",
								placeholder: "Min Age"
							}),
							/* @__PURE__ */ jsx("div", {
								className: "px-xxs my-auto",
								children: /* @__PURE__ */ jsx(Icon, {
									color: "subtle",
									Icon: TbArrowBigRightFilled
								})
							}),
							/* @__PURE__ */ jsx(FormikNumber, {
								name: "person.ageTo",
								placeholder: "Max Age"
							})
						]
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsx(FormikSelectRecordTag, {
						combineSelected: true,
						returnValueMode: "value",
						isClearable: true,
						multi: true,
						name: "person.tags",
						placeholder: "Tags",
						typeFilter: [RPCDocs.Records.GetRecordTagsList.v1.TypeFilter.Person]
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						isClearable: true,
						name: "person.race",
						options: toOptions(config?.person.race),
						placeholder: "Race"
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-1",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						isClearable: true,
						name: "person.gender",
						options: toOptions(config?.person.gender),
						placeholder: "Gender"
					})
				})
			]
		})
	});
}
//#endregion
export { PersonFields };

//# sourceMappingURL=PersonFields.js.map